
import OrderList from 'primevue/orderlist';
import IftaLabel from 'primevue/iftalabel';
import Button from 'primevue/button';
import ToggleSwitch from 'primevue/toggleswitch';
import { promotion } from '../apis/promotion';
import { useAuthStore } from '../stores/auth';
import { storeToRefs } from 'pinia';
import { computed, onMounted, ref } from 'vue';
import { GetAutoPromotionCustomersResult, ListAutoPromotion } from '../types/promotion';
import { useToast } from 'primevue/usetoast';

export default {
	name: 'PromotionSetting',
	components: {
		OrderList,
		IftaLabel,
		Button,
		ToggleSwitch,
	},
	setup() {
		const auth = useAuthStore();
		auth.hydrate();
		const { profile } = storeToRefs(auth);

		const toast = useToast();

		const loading = ref(false);
		const promotions = ref<ListAutoPromotion[]>([]);

		const promotionList = computed(() => promotions.value.filter(p => p.isPromotionActive === true));

		const form = ref({
			btn: {
				disabled: false,
				loading: false,
			},
		});

		const option = ref({
			isActive: false,
		});

		const handleAutoPromotionCustomer = async () => {
			try {
				loading.value = true;

				const payload = {
					username: profile.value?.username,
				};

				const resp = await promotion.getAutoPromotionCustomers(payload);

				if (resp.code === '8017') {
					alert(resp.message);
					await auth.logout();
					window.location.reload();
					return;
				}

				if (resp.code !== '0') throw new Error(resp.message);

				const result = resp.result as GetAutoPromotionCustomersResult;
				promotions.value = result.listPromotion;
				option.value.isActive = result.isActive;
			} catch (error: any) {
				toast.add({ severity: 'error', summary: 'โหลดข้อมูลล้มเหลว', detail: error.message || String(error), life: 3000 });
			} finally {
				loading.value = false;
			}
		};

		const handleCreateAutoPromotionCustomer = async (payload: any) => {
			const resp = await promotion.createAutoPromotionCustomers(payload);
			if (resp.code !== '0') throw new Error(resp.message);
			toast.add({ severity: 'success', summary: 'เพิ่มรายการสำเร็จ', detail: resp.message, life: 3000 });
		};

		const handleUpdateAutoPromotionCustomer = async (payload: any) => {
			const resp = await promotion.updateAutoPromotionCustomers(payload);
			if (resp.code !== '0') throw new Error(resp.message);
			toast.add({ severity: 'success', summary: 'อัปเดตรายการสำเร็จ', detail: resp.message, life: 3000 });
		};

		const formSubmit = async () => {
			form.value.btn.loading = true;

			try {
				const payload = {
					username: profile.value?.username,
					isActive: true,
					listPromotion: promotions.value.map(p => ({
						promotionId: p.id,
						promotionName: p.promotionName,
						type: p.type,
						seq: p.seq,
						isPromotionActive: p.isPromotionActive,
					})),
				};

				if (!option.value.isActive) {
					await handleCreateAutoPromotionCustomer(payload);
				} else {
					await handleUpdateAutoPromotionCustomer(payload);
				}
			} catch (error: any) {
				toast.add({ severity: 'error', summary: 'ไม่สามารถบันทึกได้', detail: error.message || String(error), life: 3000 });
			} finally {
				form.value.btn.loading = false;
			}
		};

		onMounted(() => {
			handleAutoPromotionCustomer();
		});

		return {
			promotions,
			promotionList,
			loading,
			form,
			formSubmit,
			option,
		};
	},
};
